import { Cell, Skeleton, TableRow } from "@skilitics/designer-ui-components";

import { invoicesColumns } from "./invoicesColumns";

export const InvoicesTableLoadingRows = () => (
  <>
    {[1, 2, 3].map((i) => (
      <TableRow key={i}>
        {invoicesColumns.map((column) => (
          <Cell key={column.id} align={column.align} style={{ width: column.width }}>
            <Skeleton variant="rounded" height={36} animation="wave" />
          </Cell>
        ))}
      </TableRow>
    ))}
  </>
);
